export default "__VITE_ASSET__BJbo0hQv__"